import { GlobalContext } from 'components/context/GlobalContext';
import React, { Fragment, useContext } from 'react';
import { Link } from 'react-router-dom';
import {
  Chevron,
  ChevronBack,
  ContainerChevronBack,
  ContainerSubSideNav,
  TooltipText,
} from './SubSideNav.styles';
import  { ReactHtmlParser } from 'helpers/utilities.js';
import PropTypes from 'prop-types';

export default function SubSideNav(props) {
  const { open, parentLinks, getActiveSubLink, setGetActiveSubLink, goBackMenu } = props;
  const { globalDispatch } = useContext(GlobalContext);
  return (
    <ContainerSubSideNav open={open} getActiveSubLink={getActiveSubLink} parentLinks={parentLinks}>
      {!getActiveSubLink ? (
        <Fragment>
          {/* {open && (
            <CloseButton
              onClick={() => {
                globalDispatch({
                  type: 'CLOSE_SIDEBAR',
                });
                setActiveTabIndex(null);
              }}
            >
              X
            </CloseButton>
          )} */}
          <h1>
            <Link to={parentLinks?.url}>{ReactHtmlParser(parentLinks?.title)}</Link>
          </h1>
          <ul>
            {parentLinks?.childLinks?.map(item => {
              return (
                <li key={item.title}>
                  {item.isExternal ? (
                    <a
                      href={item.url}
                      target={item.target}
                      onClick={() => {
                        globalDispatch({
                          type: 'OPEN_SIDEBAR',
                        });
                      }}
                    >
                      {ReactHtmlParser(item.title)}
                    </a>
                  ) : (
                    <Link
                      to={item.url}
                      target={item.target}
                      onClick={() => {
                        globalDispatch({
                          type: 'OPEN_SIDEBAR',
                        });
                      }}
                    >
                      {ReactHtmlParser(item.title)}
                    </Link>
                  )}
                  {item.childSubLinks.length > 0 && (
                    <div
                      onClick={() => {
                        setGetActiveSubLink(item.title);
                      }}
                    >
                      <Chevron name="chevron" />
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        </Fragment>
      ) : (
        <ContainerChevronBack
          onClick={() => {
            goBackMenu();
          }}
        >
          <ChevronBack name="chevron" />
          <TooltipText>Back</TooltipText>
        </ContainerChevronBack>
      )}
    </ContainerSubSideNav>
  );
}

SubSideNav.propTypes = {
  open: PropTypes.any,
  parentLinks: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
    childLinks: PropTypes.array,
  }),
  getActiveSubLink: PropTypes.func,
  setGetActiveSubLink: PropTypes.func,
  goBackMenu: PropTypes.func,
};
